import { render, staticRenderFns } from "./NjangiWelcomePopup.vue?vue&type=template&id=7fefd978&scoped=true"
import script from "./NjangiWelcomePopup.vue?vue&type=script&lang=js"
export * from "./NjangiWelcomePopup.vue?vue&type=script&lang=js"
import style0 from "./NjangiWelcomePopup.vue?vue&type=style&index=0&id=7fefd978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fefd978",
  null
  
)

export default component.exports